import { useIntl } from 'react-intl'
import { UseTranHook } from 'src/i18n/i18n.types'
import { getAppContext } from '../context/AppContext'

export const useTran: UseTranHook = () => {
    const country = getAppContext().config.boxylandCountry

    const intl = useIntl()

    return (key, args) => {
        const countryKey = `${key}.${country}`

        const stringExists = intl.messages?.[countryKey] !== undefined

        if (stringExists) {
            // Use country-specific translation
            return intl.formatMessage({ id: countryKey }, args)
        }

        // Fallback translation
        return intl.formatMessage({ id: key }, args)
    }
}
